// components/cart/ShippingScheduler.js
import React, { useState, useEffect, useCallback } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import tw from 'twin.macro';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { obtenerFechasOcupadas } from 'scripts/obtenerFechasOcupadas';

const Container = tw.div`flex flex-col w-full items-center`;
const ContainerDatePicker = tw.div`flex flex-col w-full items-center`;
const Title = tw.h2`text-2xl font-bold mb-4 self-start`;
const InfoText = tw.p`text-sm text-gray-600 mt-2`;

const ShippingScheduler = ({ fechaSeleccionada, setFechaSeleccionada, tieneViandas = false }) => {
	const [fechasOcupadas, setFechasOcupadas] = useState([]);

	const isDateDisabled = useCallback((date) => {
		const formattedDate = format(date, 'yyyy-MM-dd');
		return fechasOcupadas.includes(formattedDate);
	}, [fechasOcupadas]);

	const isWeekend = useCallback((date) => {
		const day = date.getDay();
		return day === 0 || day === 6; // 0 = Sunday, 6 = Saturday
	}, []);

	const isToday = useCallback((date) => {
		const normalizedDate = new Date(date);
		normalizedDate.setHours(0, 0, 0, 0);
		const today = new Date();
		today.setHours(0, 0, 0, 0);
		return normalizedDate.getTime() === today.getTime();
	}, []);

	const getNextAvailableDate = useCallback(() => {
		let date = new Date(); // Start from today
		let today = new Date();

		// Remove time from both dates for comparison
		today.setHours(0, 0, 0, 0);
		date.setHours(0, 0, 0, 0);

		// Ensure the date is not today and is not a weekend
		while (isDateDisabled(date) || isWeekend(date) || date.getTime() === today.getTime()) {
			date.setDate(date.getDate() + 1); // Move to the next day
		}

		return date;
	}, [isDateDisabled, isWeekend]);

	useEffect(() => {
		const fetchFechasOcupadas = async () => {
			try {
				const data = await obtenerFechasOcupadas();
				setFechasOcupadas(data.fechas);
			} catch (error) {
				console.error('Error al obtener fechas ocupadas:', error);
			}
		};
		fetchFechasOcupadas();
	}, []);

	useEffect(() => {
		if (!fechaSeleccionada || isDateDisabled(fechaSeleccionada) || isWeekend(fechaSeleccionada) || isToday(fechaSeleccionada)) {
			setFechaSeleccionada(getNextAvailableDate());
		}
	}, [fechaSeleccionada, setFechaSeleccionada, isDateDisabled, isWeekend, isToday, getNextAvailableDate]);

	return (
		<Container>
			<Title>{tieneViandas ? 'Selecciona la fecha de inicio' : 'Selecciona la fecha de entrega'}</Title>
			<ContainerDatePicker translate="no">
				<DatePicker
					selected={fechaSeleccionada}
					onChange={(date) => setFechaSeleccionada(date)}
					minDate={getNextAvailableDate()}
					filterDate={(date) => !isDateDisabled(date) && !isWeekend(date)}
					inline
					locale={es}
					dateFormat="dd/MM/yyyy"
				/>
			</ContainerDatePicker>
			{fechaSeleccionada && (
				<InfoText>
					{tieneViandas ? 'Fecha de inicio' : 'Fecha seleccionada'}:{' '}
					{format(fechaSeleccionada, 'dd/MM/yyyy', { locale: es })}
				</InfoText>
			)}
		</Container>
	);
};

export default ShippingScheduler;
